import React from "react";
import Skeleton from "@material-ui/lab/Skeleton";

/**
 * @author
 * @function ProductCardSkeleton
 **/
const ProductCardSkeleton = () => {
  return (
    <div  data-testid="SkeletonID" className={`ProductCardBlock productcard`}>
      <div className="card_verticalContent">
        <div className="pCardBody">
          <div className="pCardTitle">
            <Skeleton  variant="rect" height={20} width={250} />
            <Skeleton  variant="rect" height={20} width={150} />
          </div>
          <div className="pCardSummary">
            <Skeleton height={20} width={50} />
            <Skeleton height={20} width={100} />
            <Skeleton height={20} width={150} />
            <Skeleton height={20} width={200} />
            <Skeleton height={20} width={250} />
          </div>
          <div className="pCardButtonsBlock">
            <Skeleton height={40} width={150} />
          </div>
        </div>
      </div>
      <div className="desktop-illustrations">
        <div className="product-img">
          <Skeleton variant="rect" height={250} width={200} />
        </div>
      </div>
    </div>
  );
};

export default ProductCardSkeleton;
